import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import TopBar from '../../../components/TopBar/TopBar'

import InterestsSelector from '../views/InterestsSelector/InterestsSelector'

import { STEPS_ENUM, INTERESTS_STEP_PARENT_TAGS_NAMES } from './constants'

import styles from './ChooseInterests.module.scss'

const ChooseInterests = ({ tags, onSelect, currentStep, stepsCount }) => {
    const { t } = useTranslation()

    const [step] = useState(STEPS_ENUM.INTERESTS_SELECTOR)
    const [isCanGoNext, setIsCanGoNext] = useState(false)

    const [interestsTags, setInterestsTags] = useState([])
    const [selectedInterestsTags, setSelectedInterestsTags] = useState([])

    useEffect(() => {
        const _interestsTags = []
        INTERESTS_STEP_PARENT_TAGS_NAMES.forEach(tagName => {
            const tag = tags.find(tag => tag.parentTag.name === tagName && !!tag.childrenTags.length)
            if (tag) _interestsTags.push(tag)
        })
        setInterestsTags(_interestsTags)
    }, [tags])

    useEffect(() => {
        if (step === STEPS_ENUM.INTERESTS_SELECTOR) {
            setIsCanGoNext(!!selectedInterestsTags.length)
            return
        }
        setIsCanGoNext(false)
    }, [step, selectedInterestsTags])

    const onHandleNext = async () => {
        try {
            const selectedTagsNames = selectedInterestsTags.map(tag => tag.name)
            const parentTags = []
            for (const tag of tags) {
                if (!tag.childrenTags.length) continue
                if (tag.childrenTags.some(tag => selectedTagsNames.includes(tag.name))) parentTags.push(tag.parentTag)
            }
            const selectedTags = [...selectedInterestsTags, ...parentTags]
            setSelectedInterestsTags(selectedTags)
            onSelect(selectedTags)
        } catch (err) {
            console.error(err)
        }
    }

    return (
        <div className={styles.chooseInterests}>
            <TopBar
                currentStep={currentStep - 1 + step}
                stepsCount={stepsCount}
                onNext={() => onHandleNext()}
                isCanGoNext={isCanGoNext}
            />
            <div className={styles.content}>
                {step === STEPS_ENUM.INTERESTS_SELECTOR && (
                    <InterestsSelector
                        tags={interestsTags}
                        selectedTags={selectedInterestsTags}
                        onUpdateSelectedTags={data => setSelectedInterestsTags(data)}
                        descriptionTitle={t('What area do your tasks fall into?')}
                        descriptionSubTitle={t(
                            'Personalize the platform by choosing the areas that are most relevant to you. You can change answers later.',
                        )}
                        isBusiness
                    />
                )}
            </div>
        </div>
    )
}

export default ChooseInterests
